import { CommonModule } from '@angular/common';
import { Component, effect, inject, input, signal } from '@angular/core';
import { Router } from '@angular/router';
import { InError } from './documents-view/in-error/in-error';
import { Processed } from './documents-view/processed/processed';
import { ToProcess } from './documents-view/to-process/to-process';

export type DocumentTab = 'to-process' | 'processed' | 'error';

@Component({
  selector: 'app-documents',
  standalone: true,
  imports: [CommonModule, ToProcess, Processed, InError],
  templateUrl: './documents.html',
  styleUrl: './documents.scss'
})
export class Documents {
  private readonly router = inject(Router);

  // Parametri di rotta passati via withComponentInputBinding()
  indexName = input<string>('');
  tab = input<string>('to-process');

  // Tab attivo nella schermata Documenti
  activeTab = signal<DocumentTab>('to-process');

  constructor() {
    effect(() => {
      const currentTab = this.tab() as DocumentTab;
      if (currentTab === 'to-process' || currentTab === 'processed' || currentTab === 'error') {
        this.activeTab.set(currentTab);
      }
    });
  }

  selectTab(selectedTab: DocumentTab) {
    this.activeTab.set(selectedTab);
    const idx = this.indexName();
    if (idx) {
      this.router.navigate(['/', idx, 'documents', selectedTab]);
    }
  }
}